import type { ConceptDef } from '../types';

export const sortBySize: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-by-size',
  label: 'Sort by Size',
  category: 'Sorting',
  description: 'Hear a size; tap an item that matches.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'something tiny', answer: '🐜 ant' },
      { say: 'something small', answer: '🐁 mouse' },
      { say: 'something medium', answer: '🐶 dog' },
      { say: 'something big', answer: '🐎 horse' },
      { say: 'something huge', answer: '🐘 elephant' },
    ],
  },
};
